<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" fill="#2D2D2D" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.4053 15.1553C11.1124 15.4482 10.6376 15.4482 10.3447 15.1553L7.46967 12.2803C7.17678 11.9874 7.17678 11.5126 7.46967 11.2197C7.76256 10.9268 8.23744 10.9268 8.53033 11.2197L10.875 13.5643L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
      fill="#FAFAFA" />
  </svg>
</template>
